import React,  { Component } from 'react'
import { connect } from 'react-redux'
import InputText from '../components/formulario/InputText'
import {    LOGIN as loginActions,
    USUARIO as guardarUsuarioActions,
    PASO_ACTUAL_F1 as actualizaPasoActualActions,
    LOGOUT as logoutAction} from '../../service/actions'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

class SubmitCode extends Component {
    state = {
        usuario: '',
        v_usuario: '',
        v_login : false,
        cancelar: false
    }

    onChange = (e) => {
        let { value , name } = e.target;
        this.setState({[name] : value}, () => {})
    }

    cancelar = () => {
        this.setState({cancelar: true}, () => {this.props.onClick(this.state);});
    }

    setLocalStorage = (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
    }

    componentWillMount(){
        this.setState({usuario: this.props.username});
    }

    render(){
        return(
            <div className="login">
                <p className='welcome-ss'>Hola!</p>
                <p className='welcome-ss-tranqui'>Generar Codigo para restablecer contraseña</p>

                <p className={'guia-parrafo '+ (this.props.hintPassword ? 'guia-rojo' : '')}><b>El código será enviado al correo asociado a este usuario.</b></p>
                
                <InputText 
                    name = "usuario"
                    value = {this.state.usuario}
                    placeholder="Usuario"
                    onChange={this.onChange}
                    onBlur={()=>{}}
                    validate={this.state.v_usuario}
                    // minLength="8"
                    // maxLength="50"
                    origen="login"
                    mensaje=""
                    type = "text" 
                    disabled={false} />

                <Row>  
                <Col className="s6">           
                <div className="input-button">
                    <button disabled={this.props.loadingReset} onClick={()=>this.props.onClick(this.state)} className={"btn-login btn-small w100 no-box-shadow"}>
                        GENERAR CODIGO
                    </button>
                </div>
                </Col>  
                <Col className="s6">
                <div className="input-button">
                    <button onClick={()=>this.cancelar()} className={"btn-login btn-small w100 no-box-shadow"}>
                        CANCELAR
                    </button>
                </div>
                </Col>
                </Row> 

            </div>
        )
    }

}

const mapStateToProps = store => {
    return {
        usuario : store.usuario
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actualizarLogin : (isLogin) => dispatch(loginActions(isLogin)),
        guardarUsuario: (custom) => dispatch(guardarUsuarioActions(custom)),
        actualizaPasoActual : (paso) => dispatch(actualizaPasoActualActions(paso)), 
        logout : () => dispatch(logoutAction())    
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitCode)